var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.08874,
    y: 5.08874,
    width: 29.8225,
    height: 29.8225,
    rx: 14.9113,
    stroke: "currentcolor",
    strokeWidth: 2.17749
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummy);
export default __webpack_public_path__ + "static/media/dummy.44c3a55977a4ab45678a5a6b67232ecd.svg";
export { ForwardRef as ReactComponent };